module.exports = __webpack_public_path__ + "static/img/exhibitImage1.9effce47.jpg";